import React from "react";
import { useNavigate } from "react-router-dom";
import "../../../src/Components/Assests/CSS/HospitalPortalLanding.css";
import BGImg from "../../../src/Components/Assests/Images/2001.jpg";


export default function PortalLanding() {

    const navigate = useNavigate();

    return (
        <div
            className="hospital-portal-page d-flex align-items-center justify-content-center min-vh-100 position-relative overflow-hidden"
            style={{
                backgroundImage: `linear-gradient(rgba(5, 17, 35, 0.62), rgba(5, 17, 35, 0.72)), url(${BGImg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
            }}
        >
            <div className="container-fluid px-4 px-md-8">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-10 col-lg-7 col-xl-5">
                        <div className="card border-0 shadow-lg rounded-4 hospital-portal-card">
                            <div className="card-body p-4 p-md-5 text-center">
                                <div className="d-flex justify-content-center mb-4">
                                    <div className="hospital-icon-wrap">
                                        <i className="bi bi-hospital text-primary fs-1"></i>
                                    </div>
                                </div>

                                <h1 className="fw-bold text-primary mb-3 fs-2 fs-md-1">
                                    Hospital Patient Portal
                                </h1>

                                <p className="text-muted fs-5 mb-4">
                                    Scan QR & Continue
                                </p>

                                <div className="d-grid gap-3">
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-lg rounded-3 fw-bold py-3 shadow-sm"
                                    >
                                        <i className="bi bi-person-plus-fill me-2"></i>
                                        New Patient
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-outline-primary btn-lg rounded-3 fw-bold py-3 bg-white bg-opacity-75"
                                        onClick={() => navigate("/patient-login")}
                                    >
                                        <i className="bi bi-person-check-fill me-2"></i>
                                        Existing Patient
                                    </button>
                                </div>

                                <div className="mt-4 text-muted small d-flex align-items-center justify-content-center gap-2 flex-wrap">
                                    <i className="bi bi-shield-check text-success"></i>
                                    <span>Secure access for patient registration and follow-up</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
